<bn-loading-overlay></bn-loading-overlay>

<div class="row">
    <div class="col">
        <h3>Solicitação de cancelamento de garantia</h3>
    </div>

    <div class="col-auto">
        <button type="button" class="btn btn-primary" (click)="voltarParaLista()">Voltar</button>

        <button *ngIf="podeEnviarSolicitacaoCancelamento && modoEdicao " type="button" class="btn btn-primary"
            [disabled]="!solicitacoesForm?.valid" (click)="salvar()">Enviar
        </button>
    </div>
</div>

<div class="container" *ngIf="solicitacoesForm" [formGroup]="solicitacoesForm">
    <div class="row">
        <div class="col-md-8 mb-3">
            <label><b>Agente Financeiro:</b></label>
            <select class="form-select" id="idAgenteFinanceiro" name="idAgenteFinanceiro"
                formControlName="cnpjAgenteFinanceiro">
                <option [ngValue]=agente.cnpj *ngFor="let agente of agentesFinanceiros">
                    {{ agente.nome }}
                </option>
            </select>
        </div>
        <div class="col-md-4">
            <label><b>Motivo: </b></label>
            <select id="motivo" class="form-select" formControlName="ideMotivoSolicitacaoCancelamento">
                <option *ngFor="let motivo of motivosCancelamento" [value]="motivo.codigo">
                    {{ motivo.nome }}
                </option>
            </select>
        </div>
    </div>
    <div class="row">

        <div class="col mb-3" *ngIf="cancelamentoPeloGestor">
            <label><b>Val. percentual da multa (%): </b> <i class="fa fa-question-circle help-subtitulo" placement="bottom"
                ngbTooltip="O valor percentual de multa a ser aplicado sobre a base de cálculo da multa. Se for zero, então não há cobrança de multa. O valor base de cálculo da multa será definido no momento da aprovação."></i>
            </label>
            <input type="text" class="form-control moeda" formControlName="valorPercentualMulta" bnMask="DECIMAL" [casasDecimais]="2" />
        </div>

        <div class="col mb-3">
            <label><b>Sistema: <i class="fa fa-question-circle help-subtitulo" placement="bottom"
                        ngbTooltip="Sistema do contrato, constante dos Boletos de Cobrança enviados pelo BNDES, ou Crédito Livre."></i></b>
            </label>
            <select class="form-select" formControlName="sistemaRepasse" name="sistemaRepasse" id="sistemaRepasse">
                <option value=null>Crédito Livre</option>
                <option value='15'>15 - FINAME</option>
                <option value='89'>89 - BNDES</option>
            </select>
        </div>

        <div class="col mb-3">
            <label><b>Id. externo operação:</b> <i class="fa fa-question-circle help-subtitulo" placement="bottom"
                    ngbTooltip="Identificador do protocolo da operação informado pelo Agente Financeiro."></i>
            </label>
            <input type="text" class="form-control" id="idOperacaoExterno" name="idOperacaoExterno" formControlName="idOperacaoExterno">
        </div>

        <div class="mb-3 col">
            <label><b>Contrato:</b> <i class="fa fa-question-circle help-subtitulo" placement="bottom"
                    ngbTooltip="Número do contrato, constante dos Boletos de Cobrança enviados pelo BNDES."></i>
            </label>
            <input type="text" class="form-control" formControlName="contratoRepasse"  id="contratoRepasse"  name="contratoRepasse" >
        </div>

    </div>

    <div class="row">
        <div class="col-md-12">
            <label><b>{{cancelamentoPeloGestor ? 'Comentários:' : 'Justificativa:'}}</b></label>
            <textarea minlength="2" maxlength="1000" class="form-control" name="comentario" rows="4" formControlName="comentarioSolicitante"></textarea>
        </div>
    </div>
</div>

<div class="container row" *ngIf="ocorrencias?.length > 0">
    <div class="table-responsive">
        <table class="table-striped table-bordered">
            <thead>
                <tr>
                    <th class="text-center">Erro(s) encontrado(s)</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let ocorrencia of ocorrencias">
                    <td>{{ ocorrencia.mensagem }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</div>